import React, { useState, useEffect, useId } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './SkepticParts';


const StripeOKCancelModal = () => {
    const uniqueId = useId();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [messageType, setMessageType] = useState(null);
    const buttonState = 'default';

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);    
        if (params.get('custom_stripe') === 'ok') {
            setIsModalOpen(true);
            setMessageType('ok');
        }
        if (params.get('custom_stripe') === 'cancel') {
            setIsModalOpen(true);
            setMessageType('cancel');
        }
      }, []);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    if (!isModalOpen) return null;

    return(
        <>            
            <div onClick={handleModalClose} className={`${isModalOpen ? 'flex' : 'hidden'} skp_modal_wrapper`} role="dialog" aria-modal="true">
                <div className='skp_modal_window' onClick={(e) => e.stopPropagation()}>
                    
                    <motion.div whileHover={{ scale: 1.05, rotate: 12, backgroundColor: "#ff5f5f" }} onClick={handleModalClose} 
                      role="button" className='size-10 bg-skeptic-primary rounded-full absolute top-2 right-2 sm:-top-5 sm:-right-5'>
                          <svg className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <mask id={`mask_${uniqueId}`} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={24}>
                              <rect width={24} height={24} fill="#D9D9D9" />
                            </mask>
                            <g mask={`url(#mask_${uniqueId})`}><path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="white"/></g>
                          </svg>
                    </motion.div>

                    {messageType === 'ok' && (
                    <div id="success_message" className="px-12 flex flex-col justify-center items-center transition-all">
                        <div className="text-5xl">🎉📬</div>
                        <h3 className="mt-8 font-bold text-[1.75rem] text-center text-skeptic-charcoal dark:text-skeptic-foreground-dark">Thank you!</h3>
                        <p className="text-lg mt-1 text-center text-skeptic-charcoal dark:text-skeptic-foreground-dark">
                          {window.skp_member_level === 0 ? 'We’ve sent an activation link to your email!' : ''}
                        </p>
                        <div className="group mt-8">
                            <Button 
                            text={buttonState === 'loading' ? 'Loading' : 'Ok'} 
                            state={buttonState} 
                            onClick={handleModalClose} />{/* State can be default, loading, disabled */}
                        </div>
                    </div>
                    )}

                    {messageType === 'cancel' && (
                    <div id="success_message" className="px-12 flex flex-col justify-center items-center transition-all">
                        <div className="text-5xl">😞</div>
                        <h3 className="mt-8 font-bold text-[1.75rem] text-center text-skeptic-charcoal dark:text-skeptic-foreground-dark">Checkout was canceled.</h3>
                        <div className="group mt-8">
                            <Button 
                            text={buttonState === 'loading' ? 'Loading' : 'Ok'} 
                            state={buttonState} 
                            onClick={handleModalClose} />{/* State can be default, loading, disabled */}
                        </div>
                    </div>
                    )}
 
                </div>            
            </div>
        </>
    )
}

export default StripeOKCancelModal; // Default export